import { Box, Typography } from '@mui/material';
import React from 'react';
import colorData from '../../../json/color.json';

interface ImageLinkProps {
  imageUrl: string;
  title: string;
  linkTo: string;
}

/**
 * 画像リンク
 * @param imageUrl string
 * @param title string
 * @param linkTo string
 * @returns 
 */
const ImageLink: React.FC<ImageLinkProps> = ({ imageUrl, title, linkTo }) => {
  const containerStyle = {
    textAlign: 'center',
    position: 'relative',
    display: 'inline-block',
  };

  const imageStyle = {
    maxWidth: '100%',
    cursor: 'pointer',
    display: 'block',
  };

  const textStyle = {
    color: colorData['white'],
    position: 'absolute',
    left: 0,
    bottom: {xs: '8px', md: '16px'},
    padding: {xs: '4px 12px', md: '8px 20px'},
    fontSize: {xs: '14px', md: '24px', xl: '28px'},
    fontWeight: 'bold',
    backgroundColor: 'rgba(206, 27, 58, 0.9)',
    textAlign: 'left'
  };

  return (
    <Box sx={containerStyle}>
      <Typography
        component='a'
        href={linkTo}
        sx={{
          textDecoration: 'none',
        }}
      >
        <img
          loading="lazy"
          decoding="async"
          src={imageUrl}
          alt={title}
          style={imageStyle}
        />
        <Typography sx={textStyle}>{title}</Typography>
      </Typography>
    </Box>
  );
};

export default ImageLink;
